import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import uuid from 'react-uuid';

import { useForm } from 'react-hook-form';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import AddIcon from '@mui/icons-material/Add';

import FileCard from '../../../FormTickets/components/FileCard';
import FilesDropzone from '../../../FormTickets/components/FilesDropzone';
import SuccessModal from '../../../FormTickets/components/SucessModal';

import api, { authHeader } from '../../../../../../../services/API/apiConfig';

import { RootStyled, FormTitle, FieldContainer } from './styles';

export default function TicketReplyBox({ setToaster, files, setFiles }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const { id: ticketId } = useParams();

  const [responding, setResponding] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const sendMessage = async (data) => {
    const formData = new FormData();
    formData.append('rich_text', data.message);
    formData.append('raw_content', data.message);
    files.forEach((file) => {
      formData.append(
        'feedback_attachments_attributes[][attachment_file]',
        file
      );
    });

    try {
      await api.post(`/feedbacks/${ticketId}/feedback_messages`, formData, {
        headers: authHeader(true),
      });
      await api.patch(
        `/feedbacks/${ticketId}`,
        { status: 'open', read_by_admin: false },
        {
          headers: authHeader(),
        }
      );
      setModalOpen(true);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <RootStyled>
      <Typography variant="h5" gutterBottom>
        Caso não tenha ficado satisfeito(a) com a resposta recebida para a sua
        mensagem, adicione mais detalhes neste ticket.
      </Typography>

      {responding ? (
        <>
          <TextField
            fullWidth
            multiline
            rows={5}
            placeholder="Digite sua mensagem..."
            variant="outlined"
            sx={{ mb: 2 }}
            {...register('message', { required: 'Campo obrigatório' })}
            error={!!errors.message}
            helperText={
              errors.message
                ? errors.message.message
                : 'Por favor, insira os detalhes da sua solicitação. Um membro da nossa equipe de suporte responderá o mais breve possível.'
            }
          />

          <FormTitle variant="h3">Anexar arquivos (opcional)</FormTitle>
          <FieldContainer sx={{ width: '100%' }}>
            <FilesDropzone setFiles={setFiles} setToaster={setToaster} />
          </FieldContainer>

          {files.map(({ name, size }) => (
            <FileCard
              key={uuid()}
              name={name}
              size={size}
              setFiles={setFiles}
              files={files}
            />
          ))}

          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button
              variant="outlined"
              color="inherit"
              onClick={() => setResponding(false)}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit(sendMessage)}
            >
              Enviar
            </Button>
          </Box>
        </>
      ) : (
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          sx={{ mt: 2 }}
          onClick={() => setResponding(true)}
        >
          Adicionar nova mensagem
        </Button>
      )}

      <SuccessModal open={modalOpen} setOpen={setModalOpen} />
    </RootStyled>
  );
}
